<div class="shell">

  <!-- ============ PAGE HEADER ============ -->
  <header class="pagehead">
    <div>
      <app-breadcrumb />
      <h1>{{ 'RECUEILS.TITLE_PREFIX' | translate }} <span class="accent">{{ 'RECUEILS.TITLE_ACCENT' | translate }}</span></h1>
      <p class="lede">{{ 'RECUEILS.LEDE' | translate }}</p>
    </div>
  </header>

  <!-- ============ STATES ============ -->
  @if (loading()) {
    <div class="state-wrap">
      <span class="spinner"></span>
    </div>
  } @else if (error()) {
    <div class="state-wrap state-error">
      <p>{{ error() }}</p>
      <button type="button" (click)="recueilService.getRecueilsActive()">{{ 'RECUEILS.RETRY' | translate }}</button>
    </div>
  } @else {

    <!-- ============ ALL RECUEILS ============ -->
    <ls-recueil-grid style="padding: 10px 0px 40px 0px;" [showSigle]="false" [recueils]="recueils()" [basePath]="basePath" />

  }

  <!-- ============ EDITORIAL CTA ============ -->
  <div class="contrib-band">
    <div class="left">
      <h3>{{ 'RECUEILS.CTA.TITLE' | translate }}</h3>
      <p>{{ 'RECUEILS.CTA.TEXT' | translate }}</p>
    </div>
    <a [routerLink]="adminRoute(routeName.MyLyricForm)">
      {{ 'RECUEILS.CTA.BUTTON' | translate }}
      <i class="ls-ic ls-arrow-right ic-14" aria-hidden="true"></i>
    </a>
  </div>

</div>
